import React from "react";
import { Link } from "react-router-dom";
import { verifyPermission } from "helpers/permission";

const StaffTableRow = ({ staff, index, onDelete, t, userPermissions }) => {
  const showInstitution = verifyPermission(
    userPermissions,
    "list-staff-from-any-unit"
  );

  return (
    <tr key={index} role="row" className="odd">
      <td>
        {staff.is_lead && (
          <span className="kt-badge kt-badge--success kt-badge--inline">L</span>
        )}
        {staff.identite ? staff.identite.lastname : ""}&ensp;
        {staff.identite ? staff.identite.firstname : ""}
      </td>
      <td>
        {staff.identite
          ? staff.identite.telephone.map((tel, idx) =>
              idx === staff.identite.telephone.length - 1 ? tel : tel + ", "
            )
          : ""}
      </td>
      <td>
        {staff.identite
          ? staff.identite.email.map((mail, idx) =>
              idx === staff.identite.email.length - 1 ? mail : mail + ", "
            )
          : ""}
      </td>
      {verifyPermission(userPermissions, "list-staff-from-maybe-no-unit") ? (
        staff.unit ? (
          <td>{staff.unit.name["fr"]}</td>
        ) : (
          <td></td>
        )
      ) : staff.unit ? (
        <td>{staff.unit.name["fr"]}</td>
      ) : (
        <td></td>
      )}
      {showInstitution ? <td>{staff.institution?.name}</td> : null}
      <td>{staff.position ? staff.position.name["fr"] : ""}</td>
      <td>
        {(verifyPermission(userPermissions, "update-staff-from-any-unit") ||
          verifyPermission(userPermissions, "update-staff-from-my-unit") ||
          verifyPermission(
            userPermissions,
            "update-staff-from-maybe-no-unit"
          )) && (
          <Link
            to={`/settings/staffs/${staff.id}/edit`}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Modifier")}
          >
            <i className="la la-edit" />
          </Link>
        )}
        {(verifyPermission(userPermissions, "destroy-staff-from-any-unit") ||
          verifyPermission(userPermissions, "destroy-staff-from-my-unit") ||
          verifyPermission(
            userPermissions,
            "destroy-staff-from-maybe-no-unit"
          )) && (
          <button
            onClick={() => onDelete(staff.id, index)}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Supprimer")}
          >
            <i className="la la-trash" />
          </button>
        )}
      </td>
    </tr>
  );
};

export default StaffTableRow;
